import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'debounce';

import Dropdown from './../Dropdown';

import validation from './../../utils/validation';

import { userSetFieldFetch } from './../../store/user/actions';

const fieldName = 'email';

class EmailDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputValue: '',
            errorMessage: null
        };

        this.onChange = this.onChange.bind(this);
        this.debounceSave = debounce(this.debounceSave, 1000);
    }

    onChange(event) {
        const inputValue = event.target.value;
        this.setState({ inputValue });
        if (!inputValue) {
            this.setState({ errorMessage: 'email is required' });
            return;
        }
        if (!validation.isEmail(inputValue)) {
            this.setState({ errorMessage: 'email is not valid' });
            return;
        }
        this.setState({ errorMessage: null });

        const { save } = this.props;
        this.debounceSave(inputValue, save);
    }

    debounceSave(value, method) {
        method(value);
    }

    componentDidMount() {
        const { value } = this.props;
        this.setState({ inputValue: value });
    }

    render() {
        const { inputValue, errorMessage } = this.state;
        const text = inputValue || 'Enter email';
        return (
            <Dropdown buttonClassName="lnk-dropdown" text={text} title={text}>
                <input className="input-text" type="email" maxLength="100" onChange={this.onChange} autoFocus value={inputValue} placeholder="Enter your email" />
                {!!errorMessage &&
                    <div>{errorMessage}</div>
                }
            </Dropdown>
        );
    }
}

const mapStateToProps = state => ({
    value: state.user[fieldName]
});
const mapDispatchToProps = dispatch => ({
    save: value => dispatch(userSetFieldFetch(fieldName, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailDropdown);


// WEBPACK FOOTER //
// ./src/components/profile/EmailDropdown.js